import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css' // This line here

// Premium Design System
import './styles/main.scss'

import VueClipboard from 'vue-clipboard2'
import VueConfirmDialog from 'vue-confirm-dialog'
Vue.use(VueConfirmDialog)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueMaterial)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

const configFirebase = {
  apiKey: "AIzaSyBT6Ij8d8ZCMPGkZ53j3gtXy2jnTT7fWtc",
  authDomain: "ufs896vip.firebaseapp.com",
  databaseURL: "https://ufs896vip.firebaseio.com",
  projectId: "ufs896vip",
  storageBucket: "ufs896vip.appspot.com",
  messagingSenderId: "146142371608",
  appId: "1:146142371608:web:a27d0909c9f290742dc86d"
}
firebase.initializeApp(configFirebase)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
